import React from "react";
import ProfileEditComponent from "./ProfileEdit";

const ProfileEdit = () => {
    return <ProfileEditComponent />;
};

export default ProfileEdit;
